import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lmwBaseRoutes } from '../../routing/route-locales/lmw-base-routes';
import { HomeCms } from '../../interfaces/home-cms.interface';
import { environment } from 'apps/learn-my-way/src/environments/environment';
import { lmwAuthLazyLoadedState } from '../../../auth-process/common/routing/route-locales/app-routes';
import { registrationLazyLoaded } from '../../../auth-process/registration/routing/route-locales/registration-routes';


@Component({
  selector: 'lmw-base-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public homeCmsData: HomeCms;
  public userSignedIn = false;
  public browseAllSubjectsLink: string = lmwBaseRoutes.browseSubjectsStatePath;
  public reportAnIssueLink: string = lmwBaseRoutes.reportAnIssueStatePath;
  public helpLink: string = lmwBaseRoutes.helpStatePath;
  public caseStudyLink: string = lmwBaseRoutes.caseStudyStatePath;
  public myLearningLink: string = lmwBaseRoutes.myLearningHomeStatePath;
  public language: string = environment.language;
  public registrationLink = `/${lmwAuthLazyLoadedState.path}/${registrationLazyLoaded.path}`;
  

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.homeCmsData = this.route.snapshot.data.cmsData;
    this.userSignedIn = this.route.snapshot.data.userSignedIn;
  }

}
